// extracted by mini-css-extract-plugin
export default {"root":"Users_root__Ge7B3","breadcrumb":"Users_breadcrumb__yaCOz","paper":"Users_paper__oPH-C","heading":"Users_heading__CE3DM","tableRow":"Users_tableRow__KQwoK"};